import { _APBucketMingCuteArray } from './mingcute.type';

export const _APMingCuteAliasArray = {
  //customs
  add_voucher_fill: ['add-voucher'],
  astrocoins_fill: ['astrocoins', 'astrocoin'],
  clock_fill: ['clock'],
  dollar_sign_fill: ['dollar-sign'],
  extract_money_fill: ['extract-money'],
  freeze_fill: ['freeze'],
  chart_line_line: ['grow'],
  mobile_money_fill: ['mobile-money'],
  pix_fill: ['pix'],
  sack_dollar_fill: ['money-bag', 'sack-dollar'],
  send_money_fill: ['send'],
  tennis_fill: ['tennis'],
  voucher_fill: ['voucher'],
  t_shirt_line: ['t-shirt'],
  settings_1_line: ['settings-1'],
  arrow_up_arrow_down: ['arrow-up-arrow-down'],
  save_line: ['save-line'],
  arrow_right_fill: ['arrow_right_fill'],
  pause_circle_line: ['pause-circle-line'],
  user_add_line: ['user-add-line'],
  file_download_line: ['file-download-line'],
  qrcode_line: ['qrcode-line'],

  //ming cute icons
  add_circle_line: ['circle-plus'],
  add_line: ['plus'],
  alert_line: ['warning'],
  align_arrow_down_line: ['extract'],
  arrow_down_line: ['down'],
  arrow_left_down_line: ['bottomleft'],
  arrow_left_line: ['left'],
  arrow_right_line: ['right'],
  arrow_right_up_line: ['topright'],
  arrow_up_line: ['up'],
  arrows_right_line: ['double-chevron-right'],
  back_line: ['repeat'],
  bank_card_line: ['card', 'create_pin'],
  bank_line: ['bank'],
  basketball_line: ['basket'],
  notification_line: ['alerts', 'on'],
  book_4_line: ['book'],
  calendar_line: ['calendar'],
  camera_line: ['camera'],
  cellphone_line: ['mobile'],
  check_circle_fill: ['circle-check'],
  check_line: ['check'],
  checks_line: ['double-check'],
  close_circle_fill: ['circle-close'],
  close_line: ['close'],
  coin_2_line: ['coins'],
  copy_2_line: ['copy'],
  currency_bitcoin_line: ['crypto-bitcoin'],
  delete_line: ['delete'],
  file_line: ['doc'],
  dots_line: ['drag'],
  down_line: ['chevron-down'],
  exchange_dollar_line: ['exchange'],
  exit_line: ['exit'],
  eye_line: ['eye-on'],
  eye_close_line: ['eye-off'],
  upload_2_line: ['upload_line'],
  file_upload_line: ['upload'],
  filter_2_line: ['filter'],
  filter_fill: ['filter_filled'],
  fire_fill: ['fire_fill'],
  football_line: ['football'],
  gift_line: ['gift'],
  globe_fill: ['globe'],
  group_fill: ['friends'],
  headphone_line: ['headphones'],
  heart_fill: ['heart-filled'],
  heart_line: ['heart'],
  history_line: ['history'],
  home_4_line: ['home'],
  horn_line: ['announce'],
  idcard_line: ['address-card', 'id-user'],
  information_line: ['info'],
  key_2_line: ['key'],
  left_line: ['chevron-left'],
  link_2_line: ['link'],
  list_check_line: ['activities'],
  location_line: ['location'],
  lock_line: ['lock'],
  mail_line: ['email'],
  medal_line: ['loyalty'],
  menu_line: ['hamburger'],
  message_1_line: ['message'],
  minimize_line: ['minus'],
  minus_circle_fill: ['circle-minus'],
  more_1_line: ['more'],
  more_2_line: ['kebab'],
  moon_line: ['moon'],
  notification_off_line: ['off'],
  pdf_line: ['pdf'],
  edit_2_line: ['edit'],
  pic_2_line: ['image'],
  qrcode_2_line: ['qr-code'],
  question_line: ['help'],
  receive_money_line: ['receive'],
  refresh_1_line: ['reload'],
  right_line: ['chevron-right'],
  sale_line: ['discount'],
  search_line: ['search'],
  settings_5_line: ['settings'],
  share_forward_line: ['share'],
  shopping_cart_1_line: ['cart'],
  star_fill: ['star-filled'],
  star_line: ['star-line'],
  store_line: ['shop'],
  sun_line: ['sun'],
  thumb_down_2_line: ['thumb-down'],
  thumb_up_2_line: ['thumb-up'],
  transfer_3_line: ['transfer'],
  unlock_line: ['unlock'],
  up_line: ['chevron-up'],
  user_2_line: ['user', 'profile'],
  wallet_3_line: ['wallet'],
  warning_line: ['alert'],
  whatsapp_line: ['whatsapp'],
  round_fill: ['round'],
  trophy_line: ['trophy'],
} as const;

export type TAPIconAstropayAliasType = keyof typeof _APMingCuteAliasArray;
export type TAPIconAstropayType =
  | (typeof _APMingCuteAliasArray)[TAPIconAstropayAliasType][number]
  | (typeof _APBucketMingCuteArray)[number];
